import React from 'react';
import Image from '../Image';
import ImageGrid from '../ImageGrid';
import Markdown from '../Markdown';
import VimeoVideo from '../VimeoVideo';
import LinkList from '../LinkList';
import BlockQuote from '../BlockQuote';
import ColumnLists from '../ColumnLists';
import SbEditable from 'storyblok-react';

const components = {
  image: Image,
  imageGrid: ImageGrid,
  markdown: Markdown,
  vimeovideo: VimeoVideo,
  linklist: LinkList,
  blockquote: BlockQuote,
  columnLists: ColumnLists,
  _: () => null,
};

const StoryblokComponents = ({ block }) => {
  const Delegated = components[block?.component] || components._;

  return (
    <SbEditable content={block}>
      <Delegated component={block} />
    </SbEditable>
  );
};

export default StoryblokComponents;
